import { Module, VuexModule, Action } from 'vuex-module-decorators';

import {
  BASE_URL_OLD,
  TRANSFER,
  WITHDRAW,
  M_POST,
  BASE_URL,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'balance' })
export default class Balance extends VuexModule {
  @Action
  Refill(param) {
    const path = param.type === 'TRANSFER' ? BASE_URL + TRANSFER : BASE_URL_OLD + WITHDRAW;
    return Vue.axios({
      url: path,
      data: param,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }
}
